// Helper functions
export const displayQuantityWithUnit = (quote) => {
  if (!quote) return ""

  if (quote.category === "cement" || !quote.category) {
    return `${quote.quantity} ${quote.cementType === "bulker" ? "MT" : "bags"}`
  } else if (quote.category === "steel") {
    return `${quote.quantity} ${quote.quantityUnit || "tons"}`
  } else if (quote.category === "machinery") {
    return `${quote.quantity} ${quote.quantityUnit || "units"}`
  }

  return `${quote.quantity} ${quote.quantityUnit || ""}`
}

export const displayProductDetails = (quote) => {
  if (!quote) return null

  if (quote.category === "cement" || !quote.category) {
    return (
      <>
        <li>
          <span className="quotation-card__label">Brand:</span> {quote.brand}
        </li>
        <li>
          <span className="quotation-card__label">Grade:</span> {quote.grade}
        </li>
        <li>
          <span className="quotation-card__label">Type:</span> {quote.cementType || "bags"}
        </li>
        <li>
          <span className="quotation-card__label">Quantity:</span> {displayQuantityWithUnit(quote)}
        </li>
      </>
    )
  } else if (quote.category === "steel") {
    return (
      <>
        <li>
          <span className="quotation-card__label">Brand:</span> {quote.brand}
        </li>
        <li>
          <span className="quotation-card__label">Steel Grade:</span> {quote.steelGrade}
        </li>
        <li>
          <span className="quotation-card__label">Steel Type:</span> {quote.steelType}
        </li>
        <li>
          <span className="quotation-card__label">Quantity:</span> {displayQuantityWithUnit(quote)}
        </li>
      </>
    )
  } else if (quote.category === "machinery") {
    return (
      <>
        <li>
          <span className="quotation-card__label">Brand:</span> {quote.brand}
        </li>
        <li>
          <span className="quotation-card__label">Machinery Type:</span> {quote.machineryType}
        </li>
        <li>
          <span className="quotation-card__label">Capacity:</span> {quote.machineryCapacity}
        </li>
        <li>
          <span className="quotation-card__label">Condition:</span> {quote.machineryCondition}
        </li>
        <li>
          <span className="quotation-card__label">Quantity:</span> {displayQuantityWithUnit(quote)}
        </li>
      </>
    )
  }

  return null
}

export const isNegotiationLimitReached = (quote, maxNegotiations) => {
  const count = quote.negotiations ? Object.keys(quote.negotiations).length : 0
  return count >= maxNegotiations
}
